import React from "react";
import SensorBase from "./SensorBase";
import IrrigationHour from "../../../components/IrrigationHour";
import { TCustomProcessFn } from "../types";
import { TDataItem, TSensorDataResponse } from "../../../services/sensorData.service";
import { generateColorForItem } from "../util";

const FIELD = "moisture2";
const UNIT = "%";

const customProcessFn: TCustomProcessFn = (
  graphData: TSensorDataResponse 
) => {

  const updatedSample = (graphData.data ?? []).map((item:TDataItem) => ({
    ...item,
    color: generateColorForItem(
      Number(item.moisture2),
      item.minThresholdValue,
      item.minOptimalValue,
      item.maxOptimalValue,
      item.maxThresholdValue
    ),   
  }));

  return {
    sample: updatedSample,  
    min: graphData.min,  
    max: graphData.max,  
    avg: graphData.avg,  
    color: updatedSample.map((item) => item.color),  
  };
};

const Moisture2: React.FC = () => {
  return (
    <div>
      <SensorBase field={FIELD} unit={UNIT} customProcessFn={customProcessFn}></SensorBase>
      <IrrigationHour />
    </div>
  );
};

export default Moisture2;
